import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 8.41L16.59 13 18 11.59l-6-6-6 6L7.41 13 12 8.41zM6 18h12v-2H6v2z"
}), 'KeyboardCapslockTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/KeyboardCapslockTwoTone.js
// module id = 4340
// module chunks = 2